// Generated file : do not modify
import { MetaValue } from '@/extend/classes/MetaAttrib';
import Owner from '@/extend/classes/Owner';
import { ListFilter } from '@/extend/classes/ListData';
import ListData from '@/extend/classes/ListData';
import { NotifDefTypes } from '@/generated/classes/NotifDef';
import { ConnectionParamModes } from '@/generated/classes/Session';
import { storeSession } from '@/generated/stores';
import { type AxiosResponse } from 'axios';
import User from '@/extend/classes/User';
import {getRequestConfig} from "@/framework/base/helpers/HttpHelper.ts";

// Salariés
export default class Salarie extends User {
  // Adresse
  public adresseId: number;
  // Métier
  public emploiId: number;
  // Métier
  public emploiNom: string;
  // Pseudo
  public pseudo: string;
  // Date de naissance
  public dateNaissance: Date | null;
  // Nom de naissance
  public nomNaissance: string;
  // Ville de naissance
  public villeNaissance: string;
  // Département de naissance
  public departementNaissance: string;
  // Pays de naissance
  public paysNaissanceId: number;
  // Nationalité
  public paysNationaliteId: number;
  // N° sécu.
  public numeroSecu: string | null;
  // Numéro de congé spectacle
  public numeroCongeSpec: string;
  // Refus de dématérialisation
  public refusDemat: boolean;
  // Fiscalité
  public fiscalite: number;
  // Fiscalité
  public fiscaliteLabel: string;
  // Statut handicapé
  public statutHandicap: number;
  // Statut handicapé
  public statutHandicapLabel: string;
  // Date d’acquisition du statut
  public dateHandicap: Date | null;
  // RIB
  public ribId: number;
  // Premier contrat exécuté
  public hasContrat: boolean;
  // Déduction forfaitaire spécifique (DFS) pour frais professionnels
  public abattement: boolean | null;
  // Déduction forfaitaire spécifique (DFS) pour frais professionnels
  public abattementLabel: string;
  // Image
  public avatar: string;
  // Méta-attributs
  public metaValues: MetaValue[];
  // GUID de création du store
  public createId: string;
  // Commande non exécutée
  public failed: boolean;
  // Donnée pouvant être  modifiée
  public canUpdate: boolean;
  // Donnée pouvant être supprimée
  public canDelete: boolean;
  // Display des objets
  public display: string;
  // Type de notification
  public notifDefType: NotifDefTypes;
  // Identifiant
  public identifiant: string;
  // Masque du profil utilisateur
  public profil: number;
  // Masque du profil utilisateur
  public currentProfil: number;
  // Première connexion
  public firstConnexion: boolean;
  // Compte désactivé
  public disabled: boolean;
  // Numéro de client CI-98
  public client98: number;
  // Dialog migration CI-98
  public dialog98: string;
  // Mode de connexion
  public connectionMode: ConnectionParamModes;
  // Se souvenir de moi
  public rememberMe: boolean;
  // Code de vérification
  public code: string;
  // Mot de passe défini
  public hasPassword: boolean;
  // Module dont le wizard a été affiché
  public modules: string[];
  // Date dont le CGU a été accepté
  public cguAcceptedAt: Date | null;
  // Client
  public clientId: number;
  // Identifiant unique
  public id: number;
  // Civilité
  public civiliteId: number;
  // Prénom
  public prenom: string;
  // Nom
  public nom: string;
  // Qualité
  public qualiteId: number;
  // Adresse mail
  public mailId: number;
  // Adresse mail
  public mail: string;
  // Numéro de téléphone
  public numeroId: number;
  // Téléphone
  public numero: string;
  // Vérification demandée au serveur
  public verify: boolean;
  // Validation effectué par le serveur
  public valid: boolean;
  // Contact associé à un utilisateur
  public isUser: boolean;
  // Recipient id edusign
  public eduSignRecipientId: string;
  // Objet à l'origine de la requête
  public owner: Owner;

  constructor() {
    super();
    this.adresseId = 0;
    this.emploiId = 0;
    this.emploiNom = '';
    this.pseudo = '';
    this.dateNaissance = null;
    this.nomNaissance = '';
    this.villeNaissance = '';
    this.departementNaissance = '';
    this.paysNaissanceId = 0;
    this.paysNationaliteId = 0;
    this.numeroSecu = null;
    this.numeroCongeSpec = '';
    this.refusDemat = false;
    this.fiscalite = 0;
    this.fiscaliteLabel = '';
    this.statutHandicap = 0;
    this.statutHandicapLabel = '';
    this.dateHandicap = null;
    this.ribId = 0;
    this.hasContrat = false;
    this.abattement = null;
    this.abattementLabel = '';
    this.avatar = '';
    this.metaValues = [];
    this.createId = '';
    this.failed = false;
    this.canUpdate = true;
    this.canDelete = true;
    this.display = '';
    this.notifDefType = NotifDefTypes.NONE;
    this.identifiant = '';
    this.profil = 0;
    this.currentProfil = 0;
    this.firstConnexion = false;
    this.disabled = false;
    this.client98 = 0;
    this.dialog98 = '';
    this.connectionMode = ConnectionParamModes.NONE;
    this.rememberMe = false;
    this.code = '';
    this.hasPassword = false;
    this.modules = [];
    this.cguAcceptedAt = null;
    this.clientId = 0;
    this.id = 0;
    this.civiliteId = 0;
    this.prenom = '';
    this.nom = '';
    this.qualiteId = 0;
    this.mailId = 0;
    this.mail = '';
    this.numeroId = 0;
    this.numero = '';
    this.verify = false;
    this.valid = false;
    this.isUser = false;
    this.eduSignRecipientId = '';
    this.owner = new Owner();
  }

  public static fromJson (obj: Salarie): Salarie {
    const newSalarie: Salarie = new Salarie();
    newSalarie.adresseId = obj.adresseId;
    newSalarie.emploiId = obj.emploiId;
    newSalarie.emploiNom = obj.emploiNom;
    newSalarie.pseudo = obj.pseudo;
    newSalarie.dateNaissance = obj.dateNaissance ? new Date(obj.dateNaissance) : null;
    newSalarie.nomNaissance = obj.nomNaissance;
    newSalarie.villeNaissance = obj.villeNaissance;
    newSalarie.departementNaissance = obj.departementNaissance;
    newSalarie.paysNaissanceId = obj.paysNaissanceId;
    newSalarie.paysNationaliteId = obj.paysNationaliteId;
    newSalarie.numeroSecu = obj.numeroSecu;
    newSalarie.numeroCongeSpec = obj.numeroCongeSpec;
    newSalarie.refusDemat = obj.refusDemat;
    newSalarie.fiscalite = obj.fiscalite;
    newSalarie.fiscaliteLabel = obj.fiscaliteLabel;
    newSalarie.statutHandicap = obj.statutHandicap;
    newSalarie.statutHandicapLabel = obj.statutHandicapLabel;
    newSalarie.dateHandicap = obj.dateHandicap ? new Date(obj.dateHandicap) : null;
    newSalarie.ribId = obj.ribId;
    newSalarie.hasContrat = obj.hasContrat;
    newSalarie.abattement = obj.abattement;
    newSalarie.abattementLabel = obj.abattementLabel;
    newSalarie.avatar = obj.avatar;
    newSalarie.metaValues = JSON.parse(JSON.stringify(obj.metaValues));
    newSalarie.createId = obj.createId;
    newSalarie.failed = obj.failed;
    newSalarie.canUpdate = obj.canUpdate;
    newSalarie.canDelete = obj.canDelete;
    newSalarie.display = obj.display;
    newSalarie.notifDefType = obj.notifDefType;
    newSalarie.identifiant = obj.identifiant;
    newSalarie.profil = obj.profil;
    newSalarie.currentProfil = obj.currentProfil;
    newSalarie.firstConnexion = obj.firstConnexion;
    newSalarie.disabled = obj.disabled;
    newSalarie.client98 = obj.client98;
    newSalarie.dialog98 = obj.dialog98;
    newSalarie.connectionMode = obj.connectionMode;
    newSalarie.rememberMe = obj.rememberMe;
    newSalarie.code = obj.code;
    newSalarie.hasPassword = obj.hasPassword;
    newSalarie.modules = JSON.parse(JSON.stringify(obj.modules));
    newSalarie.cguAcceptedAt = obj.cguAcceptedAt ? new Date(obj.cguAcceptedAt) : null;
    newSalarie.clientId = obj.clientId;
    newSalarie.id = obj.id;
    newSalarie.civiliteId = obj.civiliteId;
    newSalarie.prenom = obj.prenom;
    newSalarie.nom = obj.nom;
    newSalarie.qualiteId = obj.qualiteId;
    newSalarie.mailId = obj.mailId;
    newSalarie.mail = obj.mail;
    newSalarie.numeroId = obj.numeroId;
    newSalarie.numero = obj.numero;
    newSalarie.verify = obj.verify;
    newSalarie.valid = obj.valid;
    newSalarie.isUser = obj.isUser;
    newSalarie.eduSignRecipientId = obj.eduSignRecipientId;
    newSalarie.owner = JSON.parse(JSON.stringify(obj.owner));
    return newSalarie;
  }

  public toJsonSalarie (): string {
    const json = {
      adresseId: this.adresseId,
      emploiId: this.emploiId,
      emploiNom: this.emploiNom,
      pseudo: this.pseudo,
      dateNaissance: this.dateNaissance ? new Date (this.dateNaissance).toString() : this.dateNaissance,
      nomNaissance: this.nomNaissance,
      villeNaissance: this.villeNaissance,
      departementNaissance: this.departementNaissance,
      paysNaissanceId: this.paysNaissanceId,
      paysNationaliteId: this.paysNationaliteId,
      numeroSecu: this.numeroSecu,
      numeroCongeSpec: this.numeroCongeSpec,
      refusDemat: this.refusDemat,
      fiscalite: this.fiscalite,
      fiscaliteLabel: this.fiscaliteLabel,
      statutHandicap: this.statutHandicap,
      statutHandicapLabel: this.statutHandicapLabel,
      dateHandicap: this.dateHandicap ? new Date (this.dateHandicap).toString() : this.dateHandicap,
      ribId: this.ribId,
      hasContrat: this.hasContrat,
      abattement: this.abattement,
      abattementLabel: this.abattementLabel,
      avatar: this.avatar,
      metaValues: this.metaValues,
      canUpdate: this.canUpdate,
      canDelete: this.canDelete,
      notifDefType: this.notifDefType,
      identifiant: this.identifiant,
      profil: this.profil,
      currentProfil: this.currentProfil,
      firstConnexion: this.firstConnexion,
      disabled: this.disabled,
      client98: this.client98,
      dialog98: this.dialog98,
      connectionMode: this.connectionMode,
      rememberMe: this.rememberMe,
      code: this.code,
      hasPassword: this.hasPassword,
      modules: this.modules,
      cguAcceptedAt: this.cguAcceptedAt ? new Date (this.cguAcceptedAt).toString() : this.cguAcceptedAt,
      civiliteId: this.civiliteId,
      prenom: this.prenom,
      nom: this.nom,
      qualiteId: this.qualiteId,
      mailId: this.mailId,
      mail: this.mail,
      numeroId: this.numeroId,
      numero: this.numero,
      verify: this.verify,
      valid: this.valid,
      isUser: this.isUser,
      eduSignRecipientId: this.eduSignRecipientId,
    }
    return JSON.stringify(json);
  }

  public fromSalarie (obj: Salarie): void {
    this.adresseId = obj.adresseId;
    this.emploiId = obj.emploiId;
    this.emploiNom = obj.emploiNom;
    this.pseudo = obj.pseudo;
    this.dateNaissance = obj.dateNaissance;
    this.nomNaissance = obj.nomNaissance;
    this.villeNaissance = obj.villeNaissance;
    this.departementNaissance = obj.departementNaissance;
    this.paysNaissanceId = obj.paysNaissanceId;
    this.paysNationaliteId = obj.paysNationaliteId;
    this.numeroSecu = obj.numeroSecu;
    this.numeroCongeSpec = obj.numeroCongeSpec;
    this.refusDemat = obj.refusDemat;
    this.fiscalite = obj.fiscalite;
    this.fiscaliteLabel = obj.fiscaliteLabel;
    this.statutHandicap = obj.statutHandicap;
    this.statutHandicapLabel = obj.statutHandicapLabel;
    this.dateHandicap = obj.dateHandicap;
    this.ribId = obj.ribId;
    this.hasContrat = obj.hasContrat;
    this.abattement = obj.abattement;
    this.abattementLabel = obj.abattementLabel;
    this.avatar = obj.avatar;
    this.metaValues = obj.metaValues;
    this.createId = obj.createId;
    this.failed = obj.failed;
    this.canUpdate = obj.canUpdate;
    this.canDelete = obj.canDelete;
    this.display = obj.display;
    this.notifDefType = obj.notifDefType;
    this.identifiant = obj.identifiant;
    this.profil = obj.profil;
    this.currentProfil = obj.currentProfil;
    this.firstConnexion = obj.firstConnexion;
    this.disabled = obj.disabled;
    this.client98 = obj.client98;
    this.dialog98 = obj.dialog98;
    this.connectionMode = obj.connectionMode;
    this.rememberMe = obj.rememberMe;
    this.code = obj.code;
    this.hasPassword = obj.hasPassword;
    this.modules = obj.modules;
    this.cguAcceptedAt = obj.cguAcceptedAt;
    this.clientId = obj.clientId;
    this.id = obj.id;
    this.civiliteId = obj.civiliteId;
    this.prenom = obj.prenom;
    this.nom = obj.nom;
    this.qualiteId = obj.qualiteId;
    this.mailId = obj.mailId;
    this.mail = obj.mail;
    this.numeroId = obj.numeroId;
    this.numero = obj.numero;
    this.verify = obj.verify;
    this.valid = obj.valid;
    this.isUser = obj.isUser;
    this.eduSignRecipientId = obj.eduSignRecipientId;
    this.owner = obj.owner;
  }

  public compareSalarie (value: Salarie): boolean {
    return (this.toJsonSalarie() == value.toJsonSalarie());
  }

  public cloneSalarie (): Salarie {
    return Salarie.fromJson(this);
  }

  public createForStoreSalarie (): Promise<Salarie> {
    return new Promise((resolve, reject) => {
      if (storeSession.httpCx != undefined) {
        return storeSession.httpCx.post('api/salaries/', this, getRequestConfig())
          .then((res: AxiosResponse) => {
            if (res.status == 200) {
              this.fromSalarie(res.data);
              resolve(this);
            } else {
              reject(res.data);
            }
          }).catch(() => {
            reject(null);
          });
      }
    });
  }

  public updateForStoreSalarie (): Promise<Salarie> {
    return new Promise((resolve, reject) => {
      if (storeSession.httpCx != undefined) {
        return storeSession.httpCx.put('api/salaries/', this, getRequestConfig())
          .then((res: AxiosResponse) => {
            if (res.status == 200) {
              this.fromSalarie(res.data);
              resolve(this);
            } else {
              reject(res.data);
            }
          }).catch(() => {
            reject(null);
          });
      }
    });
  }

  public deleteForStoreSalarie (): Promise<void> {
    return new Promise((resolve, reject) => {
      if (storeSession.httpCx != undefined) {
        return storeSession.httpCx.delete('api/salaries/' + this.id, getRequestConfig())
          .then((res: AxiosResponse) => {
            if (res.status == 200) {
              resolve();
            } else {
              reject(res.data);
            }
          }).catch(() => {
            reject(null);
          });
      }
    });
  }

  public static list (filter: ListFilter): Promise<ListData> {
    return new Promise((resolve, reject) => {
      if (storeSession.httpCx != undefined) {
        return storeSession.httpCx.post('api/salaries/list', filter, getRequestConfig())
          .then((res: AxiosResponse) => {
            if (res.status == 200) {
              resolve(res.data);
            } else {
              reject(res.data);
            }
          }).catch(() => {
            reject(null);
          });
      }
    });
  }

  public static getForStore (id: number): Promise<ListData> {
    return new Promise((resolve, reject) => {
      if (storeSession.httpCx != undefined) {
        return storeSession.httpCx.get('api/Salaries/' + id.toString(), getRequestConfig())
          .then((res: AxiosResponse) => {
            if (res.status == 200) {
              const listData = res.data as ListData;
              listData.reccords[0] = Salarie.fromJson(listData.reccords[0] as Salarie);
              resolve(listData);
            } else {
              reject(res.data);
            }
          }).catch(() => {
            reject(null);
          });
      }
    });
  }

  public static get (id: number): Promise<Salarie> {
    return new Promise((resolve, reject) => {
      if (storeSession.httpCx != undefined) {
        return storeSession.httpCx.get('api/Salaries/' + id.toString(), getRequestConfig())
          .then((res: AxiosResponse) => {
            if (res.status == 200) {
              const listData = res.data as ListData;
              const data = Salarie.fromJson(listData.reccords[0] as Salarie);
              resolve(data);
            } else {
              reject(res.data);
            }
          }).catch(() => {
            reject(null);
          });
      }
    });
  }

  public static getDate(salaries: Salarie[]) {
    salaries.forEach((item) => {
      item.dateNaissance = item.dateNaissance ? new Date(item.dateNaissance) : item.dateNaissance;
      item.dateHandicap = item.dateHandicap ? new Date(item.dateHandicap) : item.dateHandicap;
      item.cguAcceptedAt = item.cguAcceptedAt ? new Date(item.cguAcceptedAt) : item.cguAcceptedAt;
    })
  }
}
